import React from "react";

// Excel-like read-only grid used to preview a sheet before it is downloaded.
// columns: [{ header, key, width? }]   rows: [{ [key]: value }]
const ExcelPreview = ({ columns = [], rows = [], summary = "", onDownload, downloading = false, getRowFill }) => {
    const cell = { border: "1px solid #d9d9d9", padding: "4px 8px", fontSize: 13, color: "#000", verticalAlign: "top", whiteSpace: "pre-wrap" }
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="fw-medium">{summary}</span>
                <button className="btn btn-success d-flex align-items-center gap-2" onClick={onDownload} disabled={downloading || !rows.length}>
                    <i className="fa-solid fa-download"></i>{downloading ? "Downloading..." : "Download"}
                </button>
            </div>
            <div style={{ overflow: "auto", maxHeight: "calc(100vh - 190px)", border: "1px solid #d9d9d9" }}>
                <table style={{ borderCollapse: "collapse", width: "max-content", minWidth: "100%" }}>
                    <thead>
                        <tr>
                            <th style={{ ...cell, position: "sticky", top: 0, left: 0, zIndex: 3, background: "#e9ecef", textAlign: "center", minWidth: 44 }}></th>
                            {columns.map((col) => (
                                <th key={col.key} style={{ ...cell, position: "sticky", top: 0, zIndex: 2, background: "#1F4E78", color: "#fff", textAlign: "center", minWidth: Math.max((col.width || 14) * 7, 80) }}>{col.header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, i) => {
                            const fill = getRowFill ? getRowFill(row) : null
                            const bg = fill ? `#${fill}` : (i % 2 === 1 ? "#F7F9FC" : "#fff")
                            return (
                                <tr key={i} style={{ background: bg }}>
                                    <td style={{ ...cell, position: "sticky", left: 0, zIndex: 1, background: "#e9ecef", textAlign: "center", color: "#6c757d" }}>{i + 1}</td>
                                    {columns.map((col) => (
                                        <td key={col.key} style={cell}>{row[col.key] === undefined || row[col.key] === null || row[col.key] === "" ? "" : String(row[col.key])}</td>
                                    ))}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ExcelPreview;
